import React from 'react';
import { PARTNERS } from '../constants';
import RevealOnScroll from './RevealOnScroll';

const Partners: React.FC = () => {
  return (
    <section className="py-16 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RevealOnScroll>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">
            Shop Thousands of <span className="text-brand-600">Sri Lankan Stores</span>
          </h2>
          <p className="text-slate-500 mb-10">and Pay No Sri Lankan Sales Tax (Conditions Apply)</p>

          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-16">
            {PARTNERS.map((partner) => (
              <button
                key={partner.id}
                className="group relative flex items-center justify-center p-2 w-32 h-20 md:w-40 md:h-24 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300 transform hover:scale-110 focus:scale-105 focus:outline-none focus:ring-2 focus:ring-brand-400 cursor-pointer bg-transparent border-0"
                style={{ outline: 'none' }}
                aria-label={`Visit ${partner.name}`}
                onClick={() => window.open(partner.url, '_blank')}
              >
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="max-h-12 md:max-h-16 w-auto object-contain pointer-events-none"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    if (e.currentTarget.parentElement) {
                      const span = document.createElement('span');
                      span.innerText = partner.name;
                      span.className = "text-lg font-bold text-slate-400 group-hover:text-brand-600 transition-colors";
                      e.currentTarget.parentElement.appendChild(span);
                    }
                  }}
                />
              </button>
            ))}
          </div>

          <div className="mt-12">
            <button className="text-brand-600 font-semibold border border-brand-600 px-6 py-2.5 rounded hover:bg-brand-50 transition">
              See All Sri Lankan Stores
            </button>
          </div>
        </RevealOnScroll>
      </div>
    </section>
  );
};

export default Partners;